/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';
import PropTypes from 'prop-types';
import TextField from 'components/pages/SignIn/Widgets/TextField';

export default function PasswordField({
  title,
  value,
  onChange,
  autoComplete,
}) {
  return (
    <TextField
      title={title}
      type="password"
      name="password"
      inputProps={{ style: { fontSize: 24 } }}
      value={value}
      onChange={onChange}
      autoComplete={autoComplete}
    />
  );
}

PasswordField.propTypes = {
  title: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  autoComplete: PropTypes.string,
};

PasswordField.defaultProps = {
  title: '密碼',
  value: '',
  onChange: () => {},
  autoComplete: '',
};
